import useAccess from '@pkg/access/organisations/useAccess';
import useAuthStore from '@pkg/auth/useStore';
import useQuery from '../../../useQuery';

/**
 * @param {Object} [params] - Optional parameters
 * @param {String} [params.search] - Optional search query string
 * @param {Number} [params.level] - Optional level filter
 * @returns {Object}
 */
export default function useProcesses(params = {}, queryOptions = {}) {
  const { model } = useAccess();
  const hasLimitedAccess = useAuthStore((state) => state.hasLimitedAccess);
  // Support legacy string argument for backwards compatibility
  const { search = '', level } =
    typeof params === 'string' ? { search: params } : params;

  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.set('search', search);
  }
  if (level !== undefined) {
    queryParams.set('level', level);
  }

  const queryString = queryParams.toString();
  const searchPath = queryString
    ? `libraries/processes?${queryString}`
    : 'libraries/processes';
  const queryKey = queryString
    ? `libraries/processes?${queryString}`
    : 'libraries/processes';

  const options = {
    dataKey: 'data',
    dataDefault: [],
    // The API may return the process collection as a list or as a map keyed by
    // id; normalise to a list so every consumer receives an array.
    dataHandler: (result) => {
      const data = result.data?.data;
      if (Array.isArray(data)) return data;
      if (data && typeof data === 'object') return Object.values(data);
      return [];
    },
    refetchOnWindowFocus: false,
    enabled: model.edit || hasLimitedAccess,
    ...queryOptions,
  };

  async function getProcesses() {
    return await this.get(searchPath);
  }

  return useQuery(queryKey, getProcesses, options);
}
